import React from 'react'
import type { GatsbyBrowser } from 'gatsby'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { ShopifyProvider } from '@shopify/hydrogen-react'

//Providers
import { ThemeProvider } from './src/context/Theme'
import { LanguageProvider } from './src/context/Language'

// Style
import './src/styles/index.scss'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_KEY as string}>
    <ShopifyProvider
      storeDomain={process.env.PUBLIC_STORE_DOMAIN ?? ''}
      storefrontToken={process.env.PUBLIC_STOREFRONT_API_TOKEN ?? ''}
      storefrontApiVersion={'2025-07'}
      countryIsoCode={'CO'}
      languageIsoCode={'ES'}
    >
      <ThemeProvider>
        <LanguageProvider>{element}</LanguageProvider>
      </ThemeProvider>
    </ShopifyProvider>
  </GoogleReCaptchaProvider>
)
